<template>
    <div class="d-flex a-center j-center relative">
        <div class="speed" v-if="speed">{{ downloadStatus==2?speed:'0b/s' }}</div>
        <div class="dico">
            <div class="down" @click="startDownload()" v-if="downloadStatus == 1" title="下载"></div>
            <div class="stop" @click="downloadStatus = 1" v-if="downloadStatus == 2" title="暂停"></div>
            <div class="rdown" @click="startDownload()" v-if="downloadStatus == 3" title="重试">
                <i class="el-icon-refresh-left"></i>
            </div>
        </div>
        <div class="dprocess">
            <el-progress :percentage="percent" :color="downloadStatus == 3 ? '#f56c6c' : '#409eff'" :show-text="true"
                :stroke-width="4"></el-progress>
        </div>
    </div>
</template>
<script>
export default {
    name: "download",
    props: {
        api: {
            type: String
        },
        id: {
            type: Number
        },
        path: {
            type: String
        }
    },
    data() {
        return {
            percent: 0,                   //进度条
            chunkSize: 1024 * 1024 * 500,   // 单个分段大小
            downloadStatus: 1,             //1 未启动，2 正在下载 3 失败
            contentList: [],
            filesTotalSize: 1,
            filesPages: 1,
            filesCurrentPage: 0,
            speed: 0,
            db: null,
            fileName: '',
            fileType: '',
            dbID: 'FileChunksDB' + this.id,
            allChunksDownloaded: false,
            isProcess:false
        }
    },
    methods: {
        async initDB() {
            const that = this;
            return new Promise((resolve, reject) => {
                const request = indexedDB.open(that.dbID, 1);

                request.onerror = (event) => {
                    console.error('数据库打开失败:', event.target.error);
                    reject(event.target.error);
                };

                request.onsuccess = (event) => {
                    that.db = event.target.result;
                    resolve(that.db);
                };

                request.onupgradeneeded = (event) => {
                    const db = event.target.result;
                    if (!db.objectStoreNames.contains(that.dbID)) {
                        db.createObjectStore(that.dbID, { keyPath: 'chunkIndex' });
                    }
                };
            });
        },

        async clearDB() {
            const that = this;
            return new Promise((resolve, reject) => {
                const transaction = that.db.transaction([that.dbID], 'readwrite');
                const store = transaction.objectStore(that.dbID);
                const request = store.clear();

                request.onsuccess = () => resolve();
                request.onerror = (event) => {
                    console.error('清空数据库失败:', event.target.error);
                    reject(event.target.error);
                };
            });
        },

        async saveChunkToDB(chunkIndex, chunkBlob) {
            const that = this;
            console.log(`abc`);
            return new Promise((resolve, reject) => {
                console.log(`${that.dbID}`);
                const transaction = that.db.transaction([`${that.dbID}`], 'readwrite');
                const store = transaction.objectStore(that.dbID);
                const request = store.put({
                    chunkIndex,
                    data: chunkBlob
                });

                request.onsuccess = () => { resolve() };
                request.onerror = (event) => {
                    console.error('保存分片失败:', event.target.error);
                    reject(event.target.error);
                };
            });
        },
        async startDownload() {
            const that = this;
            try {
                // 初始化数据库
                if (!that.db) {
                    await that.initDB();
                };

                that.downloadStatus = 2;
                if(that.filesCurrentPage==0){
                    const response = await that.$daxios.get(`${that.api}?id=${that.id}`, {
                        headers: {
                            range: "bytes=0-1"
                        },
                        responseType: 'blob'
                    });
                    // 获取文件总大小，方便计算下载百分比
                    that.filesTotalSize = response.headers["content-range"].split("/")[1]
                    //获取文件名称和格式
                    that.fileName = response.headers["content-file-name"]
                    that.fileType = response.headers["content-file-suffix"]
                    // 计算总共页数，向上取整
                    that.filesPages = Math.ceil(that.filesTotalSize / that.chunkSize);
                };
                if(that.isProcess){return;}
                // 分片下载
                let range;

                let start = that.chunkSize * that.filesCurrentPage + (that.filesCurrentPage == 0 ? 0 : 1);
                let end = Math.min(start + that.chunkSize, that.filesTotalSize - 1);
                range = `bytes=${start}-${end}`;
                const chunkResponse = await that.$daxios.get(`${that.api}?id=${that.id}`, {
                    headers: {
                        range
                    },
                    responseType: 'blob',
                    onDownloadProgress: e => {
                        that.isProcess=true;
                        that.speed = that.formatFileSize(Number(e.rate) || 0) + '/s';
                        if(that.downloadStatus==2){
                            that.percent = Math.floor(100 * ((e.loaded + 2 + that.filesCurrentPage * that.chunkSize) / that.filesTotalSize))
                        };
                        
                    },
                }).catch (err=>{
                    that.$message({
                        message: err.message,
                        type: 'error'
                    });
                    that.downloadStatus = 3;
                });
                that.isProcess=false;
                await that.saveChunkToDB(that.filesCurrentPage, chunkResponse.data);
                that.filesCurrentPage++;
                if (that.filesCurrentPage == that.filesPages) {
                    that.downloadStatus = 1;
                    that.mergeAndDownload();
                }else if(that.filesCurrentPage<that.filesPages && that.downloadStatus==2){
                    that.startDownload();
                };
                return;
                
                for (let i = that.filesCurrentPage; i < that.filesPages; i++) {
                    if (that.downloadStatus == 2) {
                        let start = that.chunkSize * i + (i == 0 ? 0 : 1);
                        let end = Math.min(start + that.chunkSize, that.filesTotalSize - 1);
                        range = `bytes=${start}-${end}`;
                        const chunkResponse = await that.$daxios.get(`${that.api}?id=${that.id}`, {
                            headers: {
                                range
                            },
                            responseType: 'blob',
                            onDownloadProgress: e => {
                                that.speed = that.formatFileSize(Number(e.rate) || 0) + '/s';
                                that.percent = Math.floor(100 * ((e.loaded + 2 + i * that.chunkSize) / that.filesTotalSize))
                            },
                        }).catch (err=>{
                            that.$message({
                                message: err.message,
                                type: 'error'
                            });
                            that.downloadStatus = 3;
                        });
                        that.filesCurrentPage++;
                        // 存储到 IndexedDB

                        await that.saveChunkToDB(i, chunkResponse.data);
                        
                    }else{
                        break;
                    }
                };
                if (that.filesCurrentPage == that.filesPages) {
                    that.downloadStatus = 1;
                    that.mergeAndDownload();
                };
            } catch (err) {
                that.$message({
                    message: err.message,
                    type: 'error'
                });
                that.downloadStatus = 3;
            }
        },
        async getAllChunksFromDB() {
            const that = this;
            return new Promise((resolve, reject) => {
                const transaction = that.db.transaction([that.dbID], 'readonly');
                const store = transaction.objectStore(that.dbID);
                const request = store.getAll();

                request.onsuccess = (event) => resolve(event.target.result);
                request.onerror = (event) => {
                    console.error('获取分片失败:', event.target.error);
                    reject(event.target.error);
                };
            });
        },
        async mergeAndDownload() {
            const that = this;
            that.downloadStatus = 1;
            that.filesCurrentPage = 0;
            that.speed = '';
            try {
                // 获取所有分片
                const allChunks = await that.getAllChunksFromDB();

                // 按索引排序
                allChunks.sort((a, b) => a.chunkIndex - b.chunkIndex);

                // 合并 Blob
                const blobArray = allChunks.map(chunk => chunk.data);
                const mergedBlob = new Blob(blobArray, { type: that.fileType });

                // 创建下载链接
                const url = URL.createObjectURL(mergedBlob);
                const a = document.createElement('a');
                a.href = url;
                a.download = that.fileName;
                document.body.appendChild(a);
                a.click();

                // 清理
                setTimeout(() => {
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }, 100);
                // 清空之前的数据
                await that.clearDB();
                console.log('文件合并并下载完成');
            } catch (error) {
                console.error('合并失败:', error);
            }
        },
        formatFileSize(bytes) {
            if (bytes === 0) return '0b';
            const sizes = ['b', 'kb', 'M', 'G', 'TB'];
            const index = Math.floor(Math.log(bytes) / Math.log(1024));
            const formattedSize = (bytes / Math.pow(1024, index)).toFixed(2); // 保留两位小数
            return `${formattedSize}${sizes[index]}`;
        },
        downloadFile(num) {
            var that = this;
            if (!that.api || !that.id) { return; };
            let range;
            if (num) {
                //构建分片下载字节范围
                let end = Math.min(num * that.chunkSize + 1, that.filesTotalSize - 1)
                range = `bytes=${(num - 1) * that.chunkSize + 2}-${end}`;
            } else {
                // 第一次0-1方便获取总数，计算下载进度，每段下载字节范围区间
                range = "bytes=0-1";
            }
            that.downloadStatus = 2;
            that.$daxios
                .get(`${that.api}?id=${that.id}`, {
                    headers: {
                        range
                    },
                    responseType: 'blob',
                    onDownloadProgress: e => {
                        if (!num) {
                            return
                        };
                        that.speed = that.formatFileSize(Number(e.rate) || 0) + '/s';
                        that.percent = Math.floor(100 * ((e.loaded + 2 + (num - 1) * that.chunkSize) / that.filesTotalSize))
                    },
                })
                .then((res) => {
                    if (res.status === 200 || res.status === 206) {
                        if (that.filesTotalSize === 0) {
                            // 获取文件总大小，方便计算下载百分比
                            that.filesTotalSize = res.headers["content-range"].split("/")[1]
                            // 计算总共页数，向上取整
                            that.filesPages = Math.ceil(that.filesTotalSize / that.chunkSize)
                        };
                        that.contentList.push(res.data);
                        // 递归获取文件数据
                        if (that.downloadStatus == 2 && that.filesCurrentPage < that.filesPages) {
                            that.filesCurrentPage++;
                            that.downloadFile(that.filesCurrentPage)
                            return
                        }
                        if (that.downloadStatus === 1) {
                            //暂停
                            return
                        }
                        //设置下载完成

                        that.downloadStatus = 1;
                        //构造一个blob对象来处理数据
                        const blob = window.URL.createObjectURL(new Blob(that.contentList, { type: res.headers['content-type'] }));
                        // 文件名称
                        let disposition = decodeURI(res.headers['content-disposition'])
                        // 从响应头中获取文件名称
                        let fileName = decodeURIComponent(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length));
                        const link = document.createElement('a');
                        link.href = blob;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        that.$message({
                            message: "下载成功",
                            type: 'success'
                        });
                        that.downloadStatus = 1;
                    } else {
                        that.downloadStatus = 3;
                        that.$message({
                            message: "下载失败",
                            type: 'error'
                        });
                    };
                })
                .catch((err) => {
                    that.$message({
                        message: err.message,
                        type: 'error'
                    });
                    that.downloadStatus = 3;
                });
        }
    }
}
</script>
<style scoped lang="less">
.relative {
    position: relative;
    padding: 12px 0;

    .speed {
        position: absolute;
        left: 0;
        width: 100%;
        top: 0;
        line-height: 12px;
        font-size: 12px;
        text-align: center;
    }
}

.dico {
    flex: 0 0 auto;
    cursor: pointer;

    .down {
        width: 0.15rem;
        height: 0.17rem;

        display: block;
        background: url(@/assets/Icons/downloadGray.png) no-repeat center/100% 100%;

        &:hover {
            background-image: url(@/assets/Icons/downloadBlue.png);
        }
    }

    .stop {
        width: 0.15rem;
        height: 0.17rem;
        position: relative;

        &:before {
            content: "";
            position: absolute;
            width: 20%;
            height: 70%;
            background: #999;
            left: 15%;
            top: 15%;
        }

        &:after {
            content: "";
            position: absolute;
            width: 20%;
            height: 70%;
            background: #999;
            right: 15%;
            top: 15%;
        }

        &:hover {
            &:before {
                background: #2657db;
            }

            &:after {
                background: #2657db;
            }
        }
    }

    .rdown {
        font-size: 0.18rem;
        width: 0.15rem;
        height: 0.17rem;
        text-align: center;
        line-height: 0.17rem;
        color: #999;
        font-weight: bold;

        &:hover {
            color: #2657db;
        }
    }
}

.dprocess {
    flex: 0 0 auto;
    width: 120px;
}
</style>